import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge needs to know about the custom colour scale from our preset,
 * otherwise it treats `bg-surface` and `bg-raised` as unrelated classes and a
 * caller's `className` override silently loses to the component default.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'bg-color': [
        {
          bg: [
            'sunken',
            'surface',
            'raised',
            'overlay',
            'brand',
            'brand-hover',
            'brand-subtle',
            'success-bg',
            'warning-bg',
            'danger-bg',
            'info-bg',
            'neutral-bg',
          ],
        },
      ],
      'text-color': [
        {
          text: ['body', 'muted', 'subtle', 'inverse', 'on-brand', 'brand-text'],
        },
      ],
      'border-color': [{ border: ['line', 'line-strong'] }],
      shadow: [{ shadow: ['card', 'popover', 'modal'] }],
    },
  },
});

export type { ClassValue };

/** Conditional class names with conflicting Tailwind utilities resolved. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
